// extracted by mini-css-extract-plugin
export default {"UserMenu":"UserMenu_UserMenu__Ezc2Z","UserMenu__Item":"UserMenu_UserMenu__Item__sUxLP","UserMenu__Item--Btn":"UserMenu_UserMenu__Item--Btn__Esnze"};